import { memo, useState } from 'react';
import { Plus } from 'lucide-react';
import MemberCard from './card';
import CreateMemberModal from './create';
import { KawaiiButton } from '@components/button';
import { useMembers } from '@hooks/apollo/members';
import type { Member } from 'src/gql/graphql';

const LabMembers = () => {
  const { members, loading } = useMembers();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddMember = () => {
    console.log('Opening add member modal~');
    setIsModalOpen(true);
  };

  const handleCardClick = (member: Member['id']) => {
    console.log('Opening member details:', member);
    setIsModalOpen(true);
  };

  const handleCreateMember = (memberData: Partial<Member>) => {
    // Handle the new member data here
    console.log('New member:', memberData);
  };

  if (loading) return null;

  return (
    <div className="h-full flex py-8 *:px-8 flex-col">
      <div className="pb-4">
        <div className="p-4 bg-linear-to-r from-pink-100/80 to-purple-100/80 dark:from-pink-950/50 dark:to-purple-950/50 rounded-2xl shadow-lg flex justify-between items-center">
          <h1 className="text-2xl font-bold text-pink-600 dark:text-pink-300">AI Lab Members ✨</h1>
          <KawaiiButton onClick={handleAddMember}>
            <Plus size={20} />
            Add New Member
          </KawaiiButton>
        </div>
      </div>
      <div className="overflow-auto snap-y scroll-smooth snap-mandatory">
        <div className="flex-1 overflow-visible">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative">
            {members.map((member) => (
              <div key={member.id} className="snap-start p-2">
                <MemberCard key={member.id} member={member as Member} onChat={handleCardClick} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <CreateMemberModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleCreateMember}
      />
    </div>
  );
};

export default memo(LabMembers);
